module.exports = __webpack_public_path__ + "img/tms-side-panel-1-pl.b2a02d93.svg";